<template>
  <div class="aiz-main-wrapper d-flex flex-column">

    <div class="customer-fixed ico_fixed" v-if="paramMapAll['FIXED_CUSTOMER_OPEN'] === '1'"
         @click="showCustomer = true">
      <img :src="getFileViewUrl(paramMapAll['FIXED_CUSTOMER_PIC'] || `/static/ic_service2.png`)" class="ic_customer">
    </div>

    <div class="top-navbar bg-white border-bottom border-soft-secondary z-1035"
         :style="`background: ${paramMapAll['THEME_APP_TOP_PRIMARY_COLOR']} !important;color: ${paramMapAll['THEME_APP_TOP_PRIMARY_TEXT_COLOR']} !important`">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-12">
            <ul
                class="list-inline d-flex justify-content-between justify-content-lg-start mb-0"
            >
              <li>
                <LocaleDropdownMenu/>
              </li>
            </ul>
          </div>
          <div class="col-lg-9 col-12 text-right d-lg-block">
            <ul
                class="list-inline mb-0 h-100 justify-content-end align-items-center"
            >
              <li
                  class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
              >
                <a
                    v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',顶部_帮助热线,') && paramMapAll['SITE_CUSTOMER_PHONE']"
                    :href="`tel:${paramMapAll['SITE_CUSTOMER_PHONE']}`"
                    class="text-reset d-inline-block opacity-60 py-2"
                >
                  <i class="la la-phone"></i>
                  <span class="mr-1">{{ $t("帮助热线") }}</span>
                  <span>{{ paramMapAll["SITE_CUSTOMER_PHONE"] }}</span>
                </a>
              </li>
              <li
                  v-if="paramMapAll['FIXED_CUSTOMER_OPEN'] === '1'"
                  class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0 dropdown"
              >
                <div class="pt-2" @click="showCustomer = true">
                  <el-icon class="el-icon-service fs-16 mb-2"/>
                </div>
              </li>
              <template v-if="isLogin()">
                <li
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0 dropdown"
                >
                  <PopoverComp ref="notifyPopover">
                    <template #button>
                      <a
                          aria-expanded="false"
                          aria-haspopup="false"
                          class="dropdown-toggle no-arrow text-reset"
                          data-toggle="dropdown"
                          href="javascript:void(0);"
                          role="button"
                      >
                      <span class="">
                        <span class="position-relative d-inline-block">
                          <el-badge class="item" :is-dot="false" style="display: initial;"
                                    :value="noticeNum?noticeNum:null">
                            <i class="las la-bell fs-18"></i>
                          </el-badge>
                        </span>
                      </span>
                      </a>
                    </template>
                    <template #popover>
                      <div
                          class="dropdown-menu dropdown-menu-right dropdown-menu-lg py-0"
                          style="display: block"
                      >
                        <div class="p-3 bg-light border-bottom">
                          <h6 class="mb-0">{{ $t("通知") }}</h6>
                        </div>
                        <div
                            class="px-3 c-scrollbar-light overflow-auto"
                            style="max-height: 300px"
                        >
                          <messageList></messageList>
                        </div>
                        <div class="text-center border-top">
                          <a
                              class="text-reset d-block py-2"
                              href="javascript:void(0)"
                              @click="
                            $store.dispatch('user/getNoticeList');
                            showNotice = true;
                            $refs.notifyPopover.hide();
                          "
                          >
                            {{ $t("查看所有通知") }}
                          </a>
                        </div>
                      </div>
                    </template>
                  </PopoverComp>
                </li>
                <li
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="()=>userInfo.isShopUser && (paramMapAll['SHOP_SELLER_TO_BUYER_FORCE_BACK']!=='0')?jump(`${sellerSiteAddress}`):goto('/user/dashboard')"
                  >{{ $t("我的面板") }}</a
                  >
                </li>
                <li
                    v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',顶部_成为商家,')"
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="goto(`/shops/create`)"
                  >{{ $t("成为商家") }}</a
                  >
                </li>
                <li
                    v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',顶部_商家助力,')"
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="isLogin()?goto(`/shops/support`):'/login'"
                  >{{ $t("商家助力") }}</a
                  >
                </li>
                <li
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="logout"
                  >{{ $t("登出") }}</a
                  >
                </li>
              </template>
              <template v-else-if="paramMapAll['SYSTEM_VERSION']!=='L280'">
                <li
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="goto('/login')"
                  >{{ $t("买家登录") }}
                  </a>
                </li>
                <li
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="goto('/register')"
                  >{{ $t("买家注册") }}</a
                  >
                </li>
                <li
                    v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',顶部_成为商家,')"
                    class="list-inline-item mr-3 border-right border-left-0 pr-3 pl-0"
                >
                  <a
                      class="text-reset d-inline-block opacity-60 py-2"
                      href="javascript:void(0)"
                      @click="goto(`/shops/create`)"
                  >{{ $t("成为商家") }}</a
                  >
                </li>
                <li
                    v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',顶部_商家登录,')"
                    class="list-inline-item"
                >
                  <a
                      :href="`${sellerSiteAddress}/login`"
                      class="text-reset d-inline-block opacity-60 py-2"
                  >{{ $t("商家登录") }}</a
                  >
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header v-if="paramMapAll['SYSTEM_VERSION']!=='L280'" class="sticky-top z-1020 bg-white border-bottom shadow-sm full-width">
      <div class="position-relative logo-bar-area z-1"
           :style="`background: ${paramMapAll['THEME_APP_TOP_PRIMARY_COLOR']} !important;color: ${paramMapAll['THEME_APP_TOP_PRIMARY_TEXT_COLOR']} !important`">
        <div class="container">
          <div class="d-flex align-items-center">
            <div class="col-auto col-xl-3 pl-0 pr-3 d-flex align-items-center">
              <van-icon v-if="isMobile && this.$router.currentRoute.path!=='/home'" class="mr-1" size="1.5rem"
                        name="revoke" @click="$router.back()"/>
              <a
                  class="d-block py-20px mr-3 ml-0"
                  href="javascript:void(0);"
                  @click="goto('/')"
              >
                <img
                    alt="logo"
                    class="mw-100"
                    height="100"
                    :src="getLogo()"
                />
              </a>
            </div>
            <div class="d-lg-none ml-auto mr-0">
              <a
                  class="p-2 d-block text-reset"
                  href="javascript:void(0);"
                  @click="searchActive = true"
              >
                <i class="las la-search la-flip-horizontal la-2x"></i>
              </a>
            </div>

            <div
                :class="{
                active: this.searchActive,
                'd-flex': this.searchActive,
                // 'd-none': !this.searchActive
              }"
                class="flex-grow-1 front-header-search align-items-center bg-white"
            >
              <div class="position-relative flex-grow-1">
                <div class="d-flex  align-items-center">
                  <div
                      class="d-lg-none"
                      data-target=".front-header-search"
                      data-toggle="class-toggle"
                      href="javascript:void(0)"
                      @click="searchActive = false"
                  >
                    <button class="btn px-2" type="button">
                      <i class="la la-2x la-long-arrow-left"></i>
                    </button>
                  </div>
                  <div class="input-group flex-between">
                    <input
                        id="search"
                        v-model="inputKey"
                        :placeholder="$t('我是来买什么的') + '...'"
                        autocomplete="off"
                        class="border-0 border-lg form-control"
                        name="keyword"
                        type="text"
                        @blur="onBlur"
                        @focus="onFocus"
                        @click="debounceOnInput"
                        @input="debounceInput"
                        @keyup.enter="onEnterKeyUp"
                    />
                    <i v-show="inputKey" class="el-icon-close ft-16" style="margin: auto 0.5rem auto -1.6rem;
                      cursor: pointer;
                      z-index: 2002" @click="inputKey=''"/>
                    <div class="input-group-append d-none d-lg-block ">
                      <button class="btn btn-primary " @click="onEnterKeyUp">
                        <i class="la la-search la-flip-horizontal fs-18"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                    v-if="
                    inputKey &&
                      (isFocusSearch || (foundProducts && foundProducts.length))
                  "
                    class="typed-search-box stop-propagation document-click-d-none bg-white rounded shadow-lg position-absolute left-0 top-100 w-100"
                    style="min-height: 200px"
                >
                  <div
                      v-if="searching"
                      class="search-preloader absolute-top-center"
                  >
                    <div class="dot-loader">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <div
                      v-if="foundNothing"
                      class="search-nothing p-3 text-center fs-16"
                  >
                    {{ $t("对不起_找不到_相关的商品", [searchKey]) }}
                  </div>
                  <div id="search-content" class="text-left">
                    <div v-for="type in searchRenderOrder" :key="type">
                      <!-- 类别 -->
                      <div v-if="type === 'category' && foundCategories && foundCategories.length">
                        <div class="px-2 py-1 text-uppercase fs-10 text-right text-muted bg-soft-secondary">
                          {{ $t("类别") }}
                        </div>
                        <ul class="list-group list-group-raw">
                          <li
                              v-for="item in foundCategories"
                              :key="item.id"
                              class="list-group-item py-1"
                          >
                            <a :href="item.href" class="text-reset hov-text-primary">
                              {{ item.name }}
                            </a>
                          </li>
                        </ul>
                      </div>

                      <!-- 店铺 -->
                      <div v-if="type === 'shop' && foundShops && foundShops.length">
                        <div class="px-2 py-1 text-uppercase fs-10 text-right text-muted bg-soft-secondary">
                          {{ $t("店铺") }}
                        </div>
                        <ul class="list-group list-group-raw">
                          <li
                              v-for="item in foundShops"
                              :key="item.id"
                              class="list-group-item"
                          >
                            <a
                                class="text-reset"
                                href="javascript:void(0)"
                                @click="
              jump('/shop?shopId=' + item.id);
              searchActive = false;
            "
                            >
                              <div class="d-flex search-product align-items-center">
                                <div class="mr-3">
                                  <img
                                      :alt="item.name"
                                      :src="getFileViewUrl(item.imgHead)"
                                      class="size-30px img-fit2 rounded"
                                  />
                                </div>
                                <div class="flex-grow-1 overflow--hidden">
                                  <div class="product-name text-truncate fs-14 mb-5px">
                                    {{ item.name }}
                                  </div>
                                  <div class="opacity-60">
                                    {{ item.contact }}
                                  </div>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>

                      <!-- 产品 -->
                      <div v-if="type === 'product' && foundProducts && foundProducts.length">
                        <div class="px-2 py-1 text-uppercase fs-10 text-right text-muted bg-soft-secondary">
                          {{ $t("产品") }}
                        </div>
                        <ul class="list-group list-group-raw">
                          <li
                              v-for="item in foundProducts"
                              :key="item.id"
                              class="list-group-item"
                          >
                            <a
                                href="javascript:void(0)"
                                class="text-reset"
                                @click="
              jump('/product?goodsId=' + item.id + '&shopId=' + item.shopId);
              searchActive = false;
            "
                            >
                              <div class="d-flex search-product align-items-center">
                                <div class="mr-3">
                                  <img
                                      :alt="item.name"
                                      :src="getFileViewUrl(item.pic)"
                                      class="size-40px img-fit rounded"
                                  />
                                </div>
                                <div class="flex-grow-1 overflow--hidden minw-0">
                                  <div class="product-name text-truncate fs-14 mb-5px">
                                    {{ item.name }}
                                  </div>
                                  <div>
                  <span class="fw-600 fs-16 text-primary">
                    {{ formatMoney(priceDiscount(item)) }}
                  </span>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

            <div class="d-none d-lg-block ml-3 mr-0">
              <div id="compare" class="">
                <router-link
                    class="d-flex align-items-center text-reset"
                    to="/user/compare"
                >
                  <i class="la la-refresh la-2x opacity-80"></i>
                  <span class="flex-grow-1 ml-1">
                    <span class="badge badge-primary badge-inline badge-pill">{{
                        compareListItemCount
                      }}</span>
                    <span class="nav-box-text d-none d-xl-block opacity-70">{{
                        $t("对比")
                      }}</span>
                  </span>
                </router-link>
              </div>
            </div>

            <div class="d-none d-lg-block ml-3 mr-0">
              <div id="wishlist" class="">
                <router-link
                    class="d-flex align-items-center text-reset"
                    to="/user/wishlists"
                >
                  <i class="la la-heart-o la-2x opacity-80"></i>
                  <span class="flex-grow-1 ml-1">
                    <span class="badge badge-primary badge-inline badge-pill">{{
                        wishListItemCount
                      }}</span>
                    <span class="nav-box-text d-none d-xl-block opacity-70">{{
                        $t("愿望清单")
                      }}</span>
                  </span>
                </router-link>
              </div>
            </div>

            <div class="d-none d-lg-block ml-3 mr-0" data-hover="dropdown">
              <div id="cart_items" class="nav-cart-box dropdown h-100">
                <PopoverComp ref="cartPopover">
                  <template #button>
                    <a
                        class="d-flex align-items-center text-reset h-100"
                        data-display="static"
                        data-toggle="dropdown"
                        href="javascript:void(0)"
                    >
                      <i class="la la-shopping-cart la-2x opacity-80"></i>
                      <span class="flex-grow-1 ml-1">
                        <span
                            class="badge badge-primary badge-inline badge-pill cart-count"
                        >{{ userCartItemCount }}</span
                        >
                        <span
                            class="nav-box-text d-none d-xl-block opacity-70"
                        >{{ $t("购物车") }}</span
                        >
                      </span>
                    </a>
                  </template>
                  <template #popover>
                    <div
                        v-if="userCartItemCount === 0"
                        class="dropdown-menu dropdown-menu-right dropdown-menu-lg p-0 stop-propagation show"
                    >
                      <div class="text-center p-3">
                        <i class="las la-frown la-3x opacity-60 mb-3"></i>
                        <h3 class="h6 fw-700">
                          {{ $t("您的购物车是空的") }}
                        </h3>
                      </div>
                    </div>

                    <div
                        v-else
                        class="dropdown-menu dropdown-menu-right dropdown-menu-lg p-0 stop-propagation show"
                    >
                      <div class="p-3 fs-15 fw-600 p-3 border-bottom">
                        {{ $t("购物车物品") }}
                      </div>
                      <ul
                          class="h-250px overflow-auto c-scrollbar-light list-group list-group-flush"
                      >
                        <li
                            v-for="(item, index) in userCartItems"
                            :key="index"
                            class="list-group-item"
                        >
                          <span class="d-flex align-items-center">
                            <a
                                class="text-reset d-flex align-items-center flex-grow-1"
                                href="javascript:void(0)"
                                @click="
                                jump(productUrl(item.goodsId, item.shopId))
                              "
                            >
                              <img
                                  :src="
                                  getFileViewUrl(
                                    item.goodsSpecPic || item.goodsPic
                                  )
                                "
                                  alt
                                  class="img-fit size-60px rounded ls-is-cached lazyloaded"
                              />
                              <span class="minw-0 pl-2 flex-grow-1">
                                <span class="fw-600 mb-1 text-truncate-2">
                                  {{ item.goodsName }}
                                  <span
                                      v-if="isValidateSpec(item.goodsSpecName)"
                                      class="text-primary"
                                  >{{ item.goodsSpecName }}</span
                                  >
                                </span>
                                <span class=""
                                >{{ formatMoney(priceDiscount(item)) }}x</span
                                >
                                <span class="">{{ item.number }}</span>
                              </span>
                          </a>
                          <span class="">
                              <button
                                  class="btn btn-sm btn-icon stop-propagation"
                                  @click="removeFromCart(item.id)"
                              >
                                <i class="la la-close"></i>
                              </button>
                            </span>
                          </span>
                        </li>
                      </ul>
                      <div
                          class="px-3 py-2 fs-15 border-top d-flex justify-content-between"
                      >
                        <span class="opacity-60">{{ $t("小计") }}</span>
                        <span class="fw-600">{{
                            formatMoney(userCartTotalPrice)
                          }}</span>
                      </div>
                      <div class="px-3 py-2 text-center border-top">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                class="btn btn-soft-primary btn-sm"
                                href="javascript:void(0);"
                                @click="
                                $refs.cartPopover.hide();
                                goto('/user/cart');
                              "
                            >
                              {{ $t("查看购物车") }}
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a
                                class="btn btn-primary btn-sm"
                                href="javascript:void(0);"
                                @click="
                                $refs.cartPopover.hide();
                                goto('/user/checkout');
                              "
                            >
                              {{ $t("付款") }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </template>
                </PopoverComp>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white border-top border-gray-200 py-1">
        <div class="container">
          <ul class="list-inline mb-0 pl-0 mobile-hor-swipe text-center headBanner">
            <li
                v-for="banner in banners"
                :key="banner.id"
                class="headBannerItem list-inline-item mr-0 opacity-60 fs-14 px-3 py-2 d-inline-block fw-600 hov-opacity-100 text-reset"
                @click="jump(banner.url)"
            >
              {{ $t(banner.title) }}
            </li>
          </ul>
        </div>
      </div>
    </header>
    <!--      <keep-alive include="mobileLayout,layout">-->
    <router-view/>
    <!--      </keep-alive>-->
    <div>
      <SectionPolicy :posterBottoms="posterBottoms" :posterBottoms2="posterBottoms2"/>
      <SectionFooter v-if="paramMapAll['SYSTEM_VERSION'] !== 'E01'" :posterBottoms="posterBottoms" :posterBottoms2="posterBottoms2"/>
      <footer class="pt-3 pb-7 pb-xl-3 bg-black text-light">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div class="text-center text-md-left">
                <div
                    class="MsoNormal"
                    v-html="paramMapAll['SITE_COPYRIGHT']"
                ></div>
              </div>
            </div>
            <div class="col-lg-4"></div>
            <div class="col-lg-4">
              <div class="text-center text-md-right">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <img
                        alt=""
                        class="mw-100 h-auto"
                        height="30"
                        src="/static/uploads/all/A4exnDZSrAXvDu3OLWe07zbp2XXmwnQXb8iHu7jE.png"
                        style="max-height: 30px"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <NavBar/>
      <AccountPanel/>
      <ItemAddedToCartDialog/>
      <el-dialog :title="$t('系统公告')" :visible.sync="showNotice" width="80%" append-to-body>
        <el-card v-for="(item,index) in noticeList" :key="index" class="box-card mb-2">
          <div slot="header" class="clearfix">
            <span class="text-red">{{ $t(item.title) }}</span>
          </div>
          <div v-html="$t(item.content)"/>
          <div>{{ item.publishTime || item.createTime }}</div>
        </el-card>
      </el-dialog>
      <el-dialog
          v-if="showCustomer"
          :title="$t('客服')"
          :visible.sync="showCustomer"
          append-to-body
          width="80%"
      >
        <m-support/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import LocaleDropdownMenu from "@/components/LocaleDropdownMenu.vue";
import SectionPolicy from "@/components/SectionPolicy.vue";
import SectionFooter from "@/components/SectionFooter.vue";
import NavBar from "@/components/NavBar.vue";
import AccountPanel from "@/components/AccountPanel.vue";
import PopoverComp from "@/components/PopoverComp.vue";
import {DeviceUtil} from "@/utils/deviceUtil";
import ItemAddedToCartDialog from "@/components/ItemAddedToCartDialog.vue";
import {getShopList} from "@/api/userShop";
import {debounce} from "@/utils/otherUtil";
import MessageList from "@/views/user/messageList.vue";
import store from "@/store";
import MSupport from "@/views/support.vue";
import {isLogin} from "@/utils/auth";

export default {
  name: "app",
  components: {
    MSupport,
    MessageList,
    ItemAddedToCartDialog,
    PopoverComp,
    AccountPanel,
    LocaleDropdownMenu,
    SectionPolicy,
    SectionFooter,
    NavBar
  },

  data() {
    return {
      searchRenderOrder: ['category', 'product' , 'shop'], // 可根据需要动态变更
      searchActive: !DeviceUtil.isMobile(),
      inputKey: "",
      searchKey: "",
      searching: false,
      foundNothing: false,
      foundCategories: undefined,
      foundProducts: undefined,
      foundShops: undefined,
      debounceInput: null,
      isFocusSearch: false,
      banners: [],
      posterBottoms: [],
      posterBottoms2: [],
      showNotice: false,
      showCustomer: false
    };
  },
  watch: {
    '$route'() {
      if (this.$route.path === '/categories') {
        this.searchActive = true
      } else {
        this.searchActive = false
      }
      // console.log('this.$route',this.$route.path==='/categories')
      // if (this.$route.path.option === 'withdraw') {
      //   this.$nextTick(() => {
      //     this.showWithdrawModal()
      //   });
      // }
    }
  },
  computed: {
    store() {
      return store
    },
    ...Vuex.mapGetters([
      'noticeNum',
      'noticeList',
    ]),
    wishListItemCount() {
      return this.$store.state.user.wishList.length;
    },
    compareListItemCount() {
      return this.$store.state.user.compareList.length;
    }
  },
  created() {
    if (this.paramMapAll["SYSTEM_VERSION"] === 'D06'){
      this.searchRenderOrder=['category', 'shop', 'product']
    }
    this.getBannersTop();
    this.getPosterBottoms();
    this.getPosterBottoms2();
  },
  methods: {
    isLogin,
    priceDiscount(goods) {
      let buyDiscount = goods && goods.buyDiscount || 100;
      return goods && goods.price * buyDiscount / 100
    },
    onEnterKeyUp() {
      this.$router.push(`/search?t=${new Date().getTime()}&keyword=${encodeURIComponent(this.inputKey)}`);
      this.searchActive = false;
    },
    async getBannersTop() {
      this.banners = await this.getBanners("top");
    },
    debounceOnInput() {
      return debounce(this.onInput, 600)
    },
    onInput() {
      this.searchKey = this.inputKey;
      if (this.inputKey === "") {
        this.searching = false;
        this.foundNothing = this.foundCategories = this.foundProducts = this.foundShops = undefined;
        return;
      }
      this.searching = true;
      this.foundNothing = false;
      this.requestSearch(this.searchKey).then(
          ({searchKey, categories, products, shops}) => {
            if (searchKey !== this.searchKey) return;
            this.searching = false;
            this.foundCategories = categories;
            this.foundProducts = products;
            this.foundShops = shops;
            this.foundNothing = [
              this.foundCategories,
              this.foundProducts,
              this.foundShops
            ].every(item => !item);
          }
      );
    },
    onFocus() {
      this.isFocusSearch = true;
    },
    onBlur() {
      setTimeout(() => {
        this.foundProducts = [];
        this.foundShops = [];
        this.isFocusSearch = false;
      }, 300);
    },
    async requestSearch(searchText) {
      const params = {
        curPage: 1,
        pageSize: 3,
        name: searchText
      };
      const paramsGoods = {
        curPage: 1,
        pageSize: 3,
        'name': searchText
      };
      const [shopRes, productRes] = await Promise.all([
        this.$get("/userShop/page", {params}),
        this.$get("/goods/page", {params: paramsGoods})
      ]);
      const products = productRes.data.records.length
          ? productRes.data.records.slice(0, 3)
          : undefined;
      const shops = shopRes.data.records.length
          ? shopRes.data.records.slice(0, 3)
          : undefined;
      return {searchKey: searchText, categories: undefined, products, shops};
    },
    async getPosterBottoms() {
      this.posterBottoms = await this.getPosters({
        codes: [
          "supportPolicy",
          "returnPolicy",
          "privacyPolicy",
          "sellerPolicy",
          "termConditions"
        ]
      });
    },
    async getPosterBottoms2() {
      this.posterBottoms2 = await this.getPosters({
        cid: '4'
      });
    },
  },
  mounted() {
    this.debounceInput = this.debounceOnInput();
  }
};
</script>


<style lang="scss">
.ico_fixed {
  position: fixed;
  height: auto;
  right: 20px;
  bottom: 80px;
  z-index: 999;

  img {
    width: 60px;
  }
}

.headBanner {
  //width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* 当宽度不足时，允许换行 */
  //grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); /* 自动调整列数 */
  //gap: 10px; /* 子元素间距 */
  //background-color: #f0f0f0;
  //padding: 10px;
  .headBannerItem {
    //background-color: #4caf50;
    //color: #fff;
    //text-align: center;
    //padding: 20px;
    box-sizing: border-box;
  }
}

</style>


